import ForgotInvite from "./ForgotInvite";
export default ForgotInvite;
